import React, { useState } from 'react';
import { Link,useNavigate } from 'react-router-dom';
import axios from '../../api/api';
import { toast } from 'react-toastify';

const REG_URL = '/api/v4/registerviewer';

const UserRegister = () => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmpassword, setConfirmpassword] = useState('');
  const [errorEmail, setErrorEmail] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmpassword) {
      toast.error('Passwords do not match.');
      return;
    }
    if (!email.toLowerCase().endsWith('@gmail.com')) {
      setErrorEmail('Email must end with "@gmail.com"');
      return;
    }
    if (password.length < 8 || confirmpassword.length < 8) {
      setErrorMessage('Password must be more than 8 characters');
      return;
    }
    setLoading(true);
    try {
      const response = await axios.post(REG_URL,
        JSON.stringify({ firstName, lastName, email, password }),
        {
          headers: { 'Content-Type': 'application/json' },
          withCredentials: true
        }
      );
      console.log(response);
      toast.success('Registration Successful');
      setTimeout(() => {
        navigate('/user-login');
        window.location.reload()
      }, 2000);
    } catch (error) {
      if (!error?.response) {
        toast.error('No Server Response');
      } else if (error.response?.status === 400) {
        toast.error('All fields are required');
      }  else if (error.response?.status === 409) {
        toast.error('Email Already Exist');
      } else {
        toast.error('Registration Failed');
      }
      console.log(error.response)
      console.log(error);
    }finally {
      setLoading(false);
    }
  };

  return (
    <main>
      <div className='bg-[#B1B2FF]'>
        <div className='mx-auto p-4 lg:container'>
          <div className='flex items-center justify-center h-screen'>
            <div className='p-6 bg-white rounded-md'>
              <h3 className='text-xl'>Create Account.</h3>
              <form onSubmit={handleSubmit}>
                <label htmlFor='firstname'>
                  <input
                    type='text'
                    required
                    placeholder='Firstname'
                    className='mt-4 px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full rounded-md sm:text-sm focus:ring-1'
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                  />
                </label>
                <label htmlFor='Lastname'>
                  <input
                    type='text'
                    required
                    placeholder='Lastname'
                    className='mt-4 px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full rounded-md sm:text-sm focus:ring-1'
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                  />
                </label>
                {errorEmail && <div className='text-red-400'> {errorEmail} </div>}
                <label htmlFor='Email'>
                  <input
                    type='email'
                    required
                    placeholder='Email Address'
                    className='mt-4 px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full rounded-md sm:text-sm focus:ring-1'
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </label>
                {errorMessage && <div className='text-red-400'> {errorMessage} </div>}
                <label htmlFor='Password'>
                  <input
                    type='password'
                    required
                    placeholder='Password'
                    className='mt-2 px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full rounded-md sm:text-sm focus:ring-1'
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </label>
                <label htmlFor='Password'>
                  <input
                    type='password'
                    required
                    placeholder='Confirm Password'
                    className='mt-2 px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full rounded-md sm:text-sm focus:ring-1'
                    value={confirmpassword}
                    onChange={(e) => setConfirmpassword(e.target.value)}
                  />
                </label>
                <p className='mt-2 text-right hover:text-blue-600'><Link to='/user-login'>Already have an account? <u>Login</u></Link></p>
                <button
                    type='submit'
                    disabled={loading}
                    className={`bg-blue-700 text-white px-6 py-1 mt-3 rounded-sm ${
                      loading ? 'bg-blue-500' : 'hover:bg-blue-600'
                    }`}
                  >
                    {loading ? 'Please wait...' : 'Register'}
                  </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default UserRegister;
